/**
 * AppSidebar
 * Version-gated: v2 renders the classic tiered sidebar,
 * v3 renders the LeftNav (faceted search column).
 *
 * v2: Desktop only (hidden below lg), 64/224px widths.
 * v3: Desktop + tablet (hidden below md), 48/180px widths.
 */

import { isV3 } from '../../hooks/useDesignVersion';
import { AppSidebarV2 } from './AppSidebarV2';
import { LeftNav } from './LeftNav';

export function AppSidebar() {
  if (isV3()) {
    return <LeftNav />;
  }
  return <AppSidebarV2 />;
}
